import "./OurStorySection.scss";

export const OurStorySection = () => {
  return (
  <section id="story" className="our-story-section">
      <div className="our-story-card">
        <div className="our-story-image">
          <img
            src="/images/our-story.JPG"
            alt="Rita és Viktor története"
          />
        </div>

        <div className="our-story-text">
          <h2>Történetünk</h2>

          <p>
            Minden 2012 karácsonyán kezdődött. Rita rengeteg
            Eminem-ajándékot kapott, amiket természetesen rögtön
            feltöltött az általa vezetett Eminem Hungary
            Facebook-oldalra.
          </p>

          <p className="our-story-quote">
            „Mindig egy ilyen barátnőt szerettem volna. 😜”
          </p>

          <p>
            Rita belájkolta a kommentet, majd bejelölte Viktort.
            Viktor ezt mindössze három hónappal később vette észre,
            de legalább rögtön írt is Ritának.
          </p>

          <p>
            2013 óta alkotnak egy párt. Az első csókjuk a
            Margit-szigeten csattant el, ami azóta is különleges
            helyet foglal el a történetükben.
          </p>

          <p>
            Tizenkét évvel később Viktor ugyanitt tette fel a nagy
            kérdést. Rita pedig szerencsére nem gondolkodott rajta
            három hónapig. 
          </p>

          <p>
            Ha már Eminemnek köszönhetik, hogy megismerkedtek, az
            élet azt is összehozta, hogy együtt két Eminem-koncerten
            is részt vehessenek.
          </p>

          <p>
            Az évek során egymás mellett nőttek fel. A tinédzserekből
            dolgozó, felelősségteljes felnőttek lettek, egyre kevesebb
            növényük szárad ki, Kutyinak is egészen jó gazdáivá váltak,
            és most már az esküvőjük következik, ami csak Veletek lehet
            teljes!
          </p>
        </div>
      </div>
    </section>
  );
};